import React from "react"
import { graphql } from "gatsby"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default ({ social }) => (
	<React.Fragment>
		{site(social)}
		{twitter(social)}
	</React.Fragment>
)

function site(social) {
	return (
		social.site && (
			<a className="social" href={social.site}>
				<FontAwesomeIcon icon={["fas", "globe"]} />
			</a>
		)
	)
}

function twitter(social) {
	return (
		social.twitter && (
			<a className="social" href={`https://twitter.com/${social.twitter}`}>
				<FontAwesomeIcon icon={["fab", "twitter"]} />
			</a>
		)
	)
}

export const eventFragment = graphql`
	fragment Social on MarkdownRemarkFrontmatter {
		social {
			site
			twitter
		}
	}
`
